import { writable, get } from 'svelte/store'

const subtasks = writable({})

export default {
    subscribe: subtasks.subscribe,
    get: () => get(subtasks),
    set: (dict) => { subtasks.set(dict) }
  }